// extracted by mini-css-extract-plugin
export default {"input":"VerificationTemplate_input__BBE73","content":"VerificationTemplate_content__XiGEl"};